/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubscriptionPaymentType {
    VISIT = 'VISIT',
    INVOICE = 'INVOICE',
    CANCELLED_VISIT = 'CANCELLED_VISIT',
    CANCELLED_INVOICE = 'CANCELLED_INVOICE',
}
